// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "./assets/less/bootstrap.css";
import Vuex from "vuex";
import $ from "jquery";
import VueAgile from "vue-agile";
import axios from "axios";
import VueCarousel from "vue-carousel";
import CampaignCarousel from "./components/CampaignCarousel";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Toast from "vue-toast-mobile";
import VuePageTransition from "vue-page-transition";
import moment from "moment/min/moment-with-locales";
import vueIosActionSheet from "vue-ios-actionsheet";

import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "UA-6392645-20",
  router
});

Vue.use(vueIosActionSheet);
moment.locale("tr");

Vue.use(VuePageTransition);

Vue.use(ElementUI);
Vue.component("CampaignCarousel", CampaignCarousel);
Vue.use(VueCarousel);

//axios.defaults.baseURL = "https://devapi.anadoluefessk.org/api";
axios.defaults.baseURL = "https://api.anadoluefessk.org/api";
axios.defaults.headers.post["Content-Type"] = "multipart/form-data";

Vue.use(Vuex);
Vue.use(VueAgile);

Vue.prototype.$openShare = (url, title) => {
  window.vm.$iosActionSheet([
    {
      label: true,
      text: "Sosyal Medyada Paylaş"
    },
    {
      text: "Facebook",
      handle: () => {
        window.vm.$share("facebook", url, title);
      }
    },
    {
      text: "Twitter",
      handle: () => {
        window.vm.$share("twitter", url, title);
      }
    },
    {
      text: "Vazgeç"
    }
  ]);
};

Vue.prototype.$buy = link => {
  window.open(link, "_blank");
};

Vue.prototype.$share = (platform, url, title) => {
  var u = "";

  switch (platform) {
    case "facebook":
      u = "https://www.facebook.com/sharer.php?u=" + url + "&t=" + title;
      break;
    case "twitter":
      u = "https://twitter.com/intent/tweet?url=" + url + "&text=" + title;
      break;
    default:
      break;
  }

  window.open(u, "_blank").focus();
};

Vue.prototype.$dateString = date => {
  return moment(date).format("D MMMM YYYY");
};

Vue.prototype.$dateTime = date => {
  return moment(date).format("D MMMM YYYY, HH:mm");
};

Vue.prototype.$matchDate = date => {
  moment.locale('tr');
  var date2 = moment(date);
  if (date2.isValid()) {
    return moment(date2).format("D MMMM YYYY, HH:mm");
  } else {
    if (date != null) {
      return date;
    }
    return "Tarih ve saat daha sonra açıklanacaktır";
  }
};

Vue.prototype.$fromNow = date => {
  return moment
    .utc(date)
    .add(-20, "seconds")
    .local()
    .fromNow();
};

const store = new Vuex.Store({
  state: {
    menu: false,
    app: {
      match: null
    },
    user: null,
    ads: [],
    pusher: "3583da5c119ae8a29938",
    pusher_staging: "ded6ad2911f267abc111",
    modalImages: [],
    baseImageURL: "https://www.anadoluefessk.org/",
    loading: false,
    news: [],
    campaigns: [],
    matches: [],
    videos: []
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    }
  },
  getters: {
    isLogged(state) {
      return state.user != null;
    }
  }
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: { App },
  store,
  async created() {
    axios.post("statik/version").then(res => {
      this.$store.state.app = res.data;
      global.modalImages = [];

      global.user = null;

      for (var i = 1; i < 17; i++) {
        this.$store.state.modalImages.push(
          this.$store.state.baseImageURL +
            "img/player/" +
            this.$store.state.app.yearslug +
            "/mobile-fistbump/" +
            i +
            ".jpg"
        );
      }
    });

    var user = localStorage.getItem("user");

    axios.post("reklam").then(res => {
      this.$store.state.ads = res.data;
    });

    if (user === null) {
      //this.$router.push({ name: "Login" });
    } else {
      this.$store.state.user = JSON.parse(user);

      axios
        .get("uyelik/hesap?token=" + this.$store.state.user.token)
        .then(res => {
          if (res.data.status != 401) {
            this.$store.state.user = res.data.data;

            localStorage.setItem("user", JSON.stringify(res.data.data));

            //this.$router.push({ name: "Home" });
          } else {
            this.$store.state.user = null;
            localStorage.removeItem("user");
            //this.$router.push({ name: "Login" });
          }
        });
    }
  }
});

router.beforeEach((to, from, next) => {
  if ($("body").hasClass("menu-open")) {
    $("body").removeClass("menu-open");
  }
  next();
});



// WEBPACK FOOTER //
// ./src/main.js